import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, CardHeader, Col, Container, Input, Row } from "reactstrap";
import { createSelector } from "reselect";
import BarTableApi from "api/barTableApi";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import CollapseFilter from "components/Common/CollapseFilter";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import ModalPreview from "components/Common/ModalPreview";
import TooltipCustom from "components/Common/TooltipCustom";
import { useRole } from "components/Hooks/UserHooks";
import {
  COLOR_STATUS_POST,
  STATUS_POST_OPTION,
  TABLE_SHARING_OPTION,
  TABLE_TYPE_OPTION,
} from "helpers/constans";
import { formatDateStringToKorea } from "helpers/format";
import CountUp from "react-countup";
import { getBarTables } from "store/barTable/thunk";
import CreateEditBarTable from "./CreateEditBarTable";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import DropdownOption from "components/Common/DropdownOption";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import DropdownAsyncUsers from "components/Common/DropdownAsyncUsers";
import { ColorPicker } from "antd";

export interface Tag {
  id: string;
  text: string;
}

registerLocale("en", en);
registerLocale("ko", ko);

const MediaList = ({ barID }: any) => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const STATUS_USER_OPTION_LANG =
    STATUS_POST_OPTION?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const TABLE_SHARING_OPTION_LANG =
    TABLE_SHARING_OPTION?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const TABLE_TYPE_OPTION_LANG =
    TABLE_TYPE_OPTION?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const [query, setQuery]: any = useState({
    page: 1,
    limit: 30,
    keyword: "",

    sort_by: "created_at",
    order_by: "DESC",
    bar_id: barID,
  });

  const [statusSearch, setStatusSearch] = useState<any>(
    STATUS_POST_OPTION?.find((item) => item?.value === parseInt(query?.status))
      ?.value ?? ""
  );

  const [sharingSearch, setSharingSearch] = useState<any>(
    TABLE_SHARING_OPTION?.find(
      (item) => item?.value === parseInt(query?.sharing)
    )?.value ?? ""
  );

  const [typeSearch, setTypeSearch] = useState<any>(
    TABLE_TYPE_OPTION?.find((item) => item?.value === parseInt(query?.type))
      ?.value ?? ""
  );

  const [bartenderSearch, setBartenderSearch] = useState<any | null>({
    label: t("All Filter"),
    value: "all",
  });

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);

  const [itemToEdit, setItemToEdit] = useState<any>(false);

  const [keywordSearch, setKeywordSearch] = useState<string>("");

  const [listBar, setListBar] = useState<any>([]);
  const [listGroup, setListGroup] = useState<any>([]);

  const dispatch: any = useDispatch();

  const selectLayoutState = (state: any) => state.BarTable;

  const BarTableProperties = createSelector(selectLayoutState, (state) => ({
    barTables: state.barTables,
    isBarTableLoading: state.isBarTableLoading,
    isBarTableSuccess: state.isBarTableSuccess,

    error: state.error,
  }));

  // Inside your component
  const { barTables, isBarTableLoading } = useSelector(BarTableProperties);

  function loadTableData() {
    dispatch(getBarTables(query));
  }

  useEffect(() => {
    console.log("loadData");
    loadTableData();
  }, [dispatch, JSON.stringify(query)]);

  const [linkImage, setLinkImage] = useState<any>(null);
  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  const searchData = () => {
    setQuery({
      ...query,
      keyword: keywordSearch || "",
      bar_id: barID,
      status: statusSearch?.value,
      type: typeSearch?.value,
      sharing: sharingSearch?.value,
      service_user_id: bartenderSearch?.value,
      sort_by: "created_at",
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        keyword: "",
        bar_id: null,
        status: "",
        type: "",
        sharing: "",
        service_user_id: "",
        start_date: "",
        end_date: "",
        sort_by: "created_at",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setKeywordSearch((_prev: any) => "");
    setStatusSearch((_prev: any) => "");
    setSharingSearch((_prev: any) => "");
    setTypeSearch((_prev: any) => "");
    setBartenderSearch((_prev: any) => "");
  };

  const handleOnConfirmUpdate = async (item: {
    id: number | string;
    status: string | boolean;
  }) => {
    try {
      if (!item) {
        return;
      }
      const response: any = await BarTableApi?.updateBarTable(item.id, {
        status: Number(item?.status),
      });
      console.log(item);

      if (response?.data) {
        dispatch(getBarTables(query));
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 50,
        Cell: ({ ...props }) => {
          return (
            <div>
              {barTables?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        filterable: true,
        sortable: false,
        thWidth: 100,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <div className="form-check form-switch form-switch-sm" dir="ltr">
              <input
                type="checkbox"
                className="form-check-input"
                name="status"
                id="customSwitchsizelg"
                checked={item?.status === 1}
                onChange={(e) => {
                  const value = e?.target?.checked;
                  handleOnConfirmUpdate({
                    id: item?.id,
                    status: !!value ? "1" : "0",
                  });
                }}
              />
            </div>
          );
        },
      },
      {
        Header: t("Code"),
        accessor: "code",
        filterable: true,
        sortable: false,
        thWidth: 100,
        Cell: (cell: any) => {
          return <>{cell?.value}</>;
        },
      },
      {
        Header: t("Name"),
        accessor: "name",
        filterable: true,
        sortable: false,
        thWidth: 100,
        Cell: (cell: any) => {
          return <>{cell?.value}</>;
        },
      },
      {
        Header: t("Color"),
        accessor: "color",
        filterable: true,
        sortable: false,
        thWidth: 100,
        Cell: (cell: any) => {
          return (
            <ColorPicker
              defaultValue="#1677ff"
              showText
              allowClear
              value={cell?.value}
              disabled
            />
          );
        },
      },
      {
        Header: t("Position"),
        accessor: "position",
        filterable: true,
        sortable: false,
        thWidth: 100,
        thClass: "text-center",
        Cell: (cell: any) => {
          return <div className="text-center">{cell?.value}</div>;
        },
      },
      {
        Header: t("Capacity"),
        accessor: "capacity",
        filterable: true,
        sortable: false,
        thWidth: 100,
        Cell: (cell: any) => {
          return <div className="text-center">{cell?.value}</div>;
        },
      },
      {
        Header: t("Type"),
        accessor: "type",
        filterable: true,
        sortable: false,
        thWidth: 100,
        thClass: "text-center",
        Cell: (cell: any) => {
          const type = TABLE_TYPE_OPTION.find(
            (i: any) => i?.value === cell?.value
          );
          return <div className="text-center">{type?.label}</div>;
        },
      },
      {
        Header: t("Time Service"),
        accessor: "time_service",
        filterable: true,
        sortable: false,
        thWidth: 100,
        thClass: "text-center",

        Cell: (cell: any) => {
          return <div className="text-center">{cell?.value}</div>;
        },
      },
      {
        Header: t("Share"),
        accessor: "sharing",
        filterable: true,
        sortable: false,
        thWidth: 100,
        thClass: "text-center",
        Cell: (cell: any) => {
          const sharing = TABLE_SHARING_OPTION.find(
            (i: any) => i?.value === cell?.value
          );
          return <div className="text-center">{sharing?.label}</div>;
        },
      },
      {
        Header: t("Service Username"),
        accessor: "u_name",
        filterable: true,
        sortable: false,
        thWidth: 150,
        Cell: (cell: any) => {
          return <>{cell?.value}</>;
        },
      },

      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: true,
        sortable: true,
        thWidth: 150,
        thClass: "text-end",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end pe-3" style={{ minWidth: "120px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Updated at"),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "text-end",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Button Action"),
        thClass: "text-center",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0"
              style={{ justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${barID}`}
              >
                <li className="list-inline-item" id={`update-md-${barID}`}>
                  <Link
                    className="btn btn-sm btn-soft-primary edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsOpen(true);
                      setItemToEdit(item);
                    }}
                  >
                    <i className="ri-pencil-fill align-bottom "></i>
                  </Link>
                </li>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${barID}`}
              >
                <li className="list-inline-item" id={`delete-md-${barID}`}>
                  <Link
                    className="btn btn-sm btn-soft-danger edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setItemToDelete(item);
                    }}
                  >
                    <i className="ri-delete-bin-3-fill align-bottom"></i>
                  </Link>
                </li>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    [i18n?.language, barTables?.total]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
  }, []);

  // Begin::Delete

  const handleActionDelete = async (id: any) => {
    if (!id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await BarTableApi?.deleteBarTable(id);
      if (response?.code == 200) {
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        setItemToDelete(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  // End::Delete
  // console.log(barID);

  useEffect(() => {
    document.title = `${t("Menu")}| Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);
  return (
    <React.Fragment>
      <div>
        <Container fluid>
          <Row>
            <Col lg={12}>
              <div
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={barTables?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                    <div className="col-sm-auto text-end">
                      <button
                        type="button"
                        className="btn btn-success d-md-block"
                        onClick={() => {
                          setIsOpen(true);
                          setItemToEdit(null);
                        }}
                      >
                        <i className="ri-add-fill align-bottom me-1"></i>{" "}
                        {t("Create")}
                      </button>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4 px-0">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-md-2 mt-0">
                      <Col
                        sm={12}
                        md={4}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Name")}
                          isShow={!!keywordSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Name")}...`}
                            value={keywordSearch}
                            onChange={(e) => setKeywordSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={4}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Service User")} isShow={true}>
                          <DropdownAsyncUsers
                            name="bartender"
                            onChangeSelect={(event: any) =>
                              setBartenderSearch(event)
                            }
                            isMulti={false}
                            placeholder={`${t("Select Service User")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedUsers={bartenderSearch}
                            keywordSearch={barID}
                            defaultParams={{ is_active: 1 }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={4}
                        xl={2}
                        xxl={2}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={STATUS_USER_OPTION_LANG || []}
                            placeholder={`${t("Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_POST}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={4}
                        xl={2}
                        xxl={2}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Sharing")} isShow={true}>
                          <DropdownStatusNew
                            name="sharing option"
                            dataList={TABLE_SHARING_OPTION_LANG || []}
                            placeholder={`${t("Table Sharing")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={sharingSearch}
                            onChangeSelect={(e: any) => setSharingSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_POST}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={4}
                        xl={2}
                        xxl={2}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Type")} isShow={true}>
                          <DropdownOption
                            name="os"
                            dataList={TABLE_TYPE_OPTION_LANG || []}
                            placeholder={`${t("Table Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={typeSearch || null}
                            onChangeSelect={(e: any) => setTypeSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>


                      <Col
                        sm={12}
                        md={4}
                        xl={12}
                        xxl={12}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                            disabled={isBarTableLoading}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={barTables?.list?.length ? barTables?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={barTables?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(barTables?.pagination?.total) /
                        Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isBarTableLoading}
                    />
                  </div>
                </CardBody>
              </div>
            </Col>
          </Row>
        </Container>
        {itemToDelete && (
          <ModalConfirm
            header={t("Button Delete")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        {isOpen && (
          <CreateEditBarTable
            setIsOpen={setIsOpen}
            barID={barID}
            item={itemToEdit}
            setItemToEdit={setItemToEdit}
            loadTableData={loadTableData}
            listBar={listBar}
            listGroup={listGroup}
            linkImage={linkImage}
            setLinkImage={setLinkImage}
            onCloseImageClick={onCloseImageClick}
          />
        )}

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        {/* <ModalConfirm
          textButtonConfirm={t('Button Update')}
          classButtonConfirm='btn-primary'
          classIconButtonConfirm=''
          header={(String(itemUpdate?.status) === ENUM_STATUS_FEED.ACTIVATED) ? t('Confirm to ON') : t('Confirm to OFF')}
          title={t('Are you sure you want to update this?')}
          content={t('After confirming the update action, the data will be updated. Do you want to proceed with the update action.')}
          isShowIcon={false}
          isOpen={!!itemUpdate}
          isLoading={isLoadingUpdate}
          onClose={() => setItemUpdate((prev: any) => null)}
          onConfirm={handleOnConfirmUpdate}
        /> */}
      </div>
    </React.Fragment>
  );
};

export default MediaList;
